import { COMPANY_COLORS } from '@/constants/colors.constant'
import { RADashboardTheme } from '@/interfaces/raDashboard.interface'

const NormalTheme: Readonly<RADashboardTheme> = Object.freeze({
  fontFamily: '"Noto Sans", sans-serif',
  // cwan-ux: temporary copy of cwan token values — remove/repoint after cwan-ux package adoption
  background: 'linear-gradient(270deg, rgba(235, 229, 255, 0.45) 0%, rgba(234, 243, 255, 0.45) 80%), #ffffff',
  cardBackground: '#ffffff',
  inputBackground: '#ffffff',
  headerBackground: '#ffffff',
  textPrimary: '#363636',
  textSecondary: '#08326d',
  border: '#e5e5e5',
  // end cwan-ux
  subheaderBackground: '#E9EEF7',
  buttonBackground: '#f3f4f6',
  buttonText: '#374151',
  boxShadowColor: 'rgba(0,0,0,0.05)',
  toggleBackground: '#f7fafc',
  toggleBorderColor: '#e2e8f0',
  togglePrimary: '#2d3748',
  configBoxShadowColor: 'rgba(0,0,0,0.08)',
  benchmarkBoxShadowColor: 'rgba(0,0,0,0.1)',
  runButtonBackground: 'var(--cwan-palette-primary-dark, #004281)',
  runButtonColor: '#ffffff',
  runButtonBoxShadowColor: 'rgba(0, 0, 0, 0.2)',
  tabBackground: '#ECECF0',
  tabSelectedBackground: '#ffffff',
  factorLensGridBoxColor: '#EFF6FF',
  factorLensGridBoxBorder: '#BEDBFF',
  factorLensGridPrimaryColor: '#155DFC',
  factorLensTotalColor: '#ebebeb',
  factorLensTotalBorder: '#afafaf',
  factorLensTotalSelected: COMPANY_COLORS.NEUTRAL_GREY, // cwan grey (readable on light card)
  factorLensSpecificColor: 'rgb(253, 243, 210)',
  factorLensSpecificBorder: 'rgb(240, 200, 110)',
  factorLensSpecificSelected: 'rgb(240, 176, 24)', // cwan-ux WARNING amber (#f0b018)
})

const DarkModeTheme: Readonly<RADashboardTheme> = Object.freeze({
  fontFamily: '"Noto Sans", sans-serif',
  // cwan-ux: temporary copy of cwan token values — remove/repoint after cwan-ux package adoption
  background: '#121212',
  cardBackground: '#1e1e1e',
  inputBackground: '#1e1e1e',
  headerBackground: '#1e1e1e',
  textPrimary: '#e0e0e0',
  textSecondary: '#aaaaaa',
  border: '#2e2e2e',
  // end cwan-ux
  subheaderBackground: '#171c25',
  buttonBackground: '#2a2a2a',
  buttonText: '#ffffff',
  boxShadowColor: 'rgba(0, 0, 0, 0.2)',
  toggleBackground: '#2d3748',
  toggleBorderColor: '#4a5568',
  togglePrimary: '#f7fafc',
  configBoxShadowColor: 'rgba(0, 0, 0, 0.3)',
  benchmarkBoxShadowColor: 'rgba(0, 0, 0, 0.3)',
  runButtonBackground: 'var(--cwan-palette-primary-dark, #004281)',
  runButtonColor: '#ffffff',
  runButtonBoxShadowColor: 'rgba(0, 0, 0, 0.2)',
  tabBackground: '#1f2937',
  tabSelectedBackground: '#1a1a1a',
  factorLensGridBoxColor: '#162556',
  factorLensGridBoxHoverColor: '#1d2f68',
  factorLensGridBoxBorder: '#193cb8',
  factorLensGridPrimaryColor: '#8ec5ff',
  factorLensTotalColor: '#2a2a2a',
  factorLensTotalBorder: '#5a5a5a',
  factorLensTotalSelected: COMPANY_COLORS.WHITE, // cwan white (readable on dark card)
  factorLensSpecificColor: 'rgb(60, 48, 20)',
  factorLensSpecificBorder: 'rgb(140, 105, 40)',
  factorLensSpecificSelected: 'rgb(240, 176, 24)', // cwan-ux WARNING amber (#f0b018)
})

// Simple Color System
export const createTheme = (isDarkMode: boolean) => (isDarkMode ? DarkModeTheme : NormalTheme)
